// Wait for DOM to be fully loaded
// document.addEventListener("DOMContentLoaded", function () {
    // Main function to handle form submission with reCAPTCHA
    function handleFormSubmit(form) {
        // console.log("Handling form submission for form: ", form);
        let formId = form.id;
        // console.log("Submitting form with ID: ", formId);

        const submitButton = form.querySelector(
            'button[type="submit"], input[type="submit"]',
        );
        const originalButtonText = submitButton
            ? submitButton.textContent
            : "Submit";

        // Disable submit button
        if (submitButton) {
            submitButton.disabled = true;
            submitButton.textContent = "Validating...";
        }

        grecaptcha.ready(function () {
            grecaptcha
                .execute("6Lelt8orAAAAAM8uwFDp_03tVvZTNcgHEZB_FAjI", {
                    action: "submit",
                })
                .then(function (token) {
                    // console.log("token ", token)
                    // token = "invalid_token_for_testing";
                    // First validate reCAPTCHA on server
                    fetch("https://formscabinetstogo.com/recaptcha-validate.php", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({ token: token }),
                    })
                        .then((response) => response.json())
                        .then((data) => {
                            let formCont = document.querySelector('.newCustomForm');
                            if (formCont) {
                                const y = formCont.getBoundingClientRect().top + window.scrollY - 150;
                                window.scrollTo({ top: y, behavior: "smooth" });
                                formCont.style = 'height:300px';
                            } else {
                                console.warn('.newCustomForm not found');
                            }
                            // console.log('data log ', data)
                            if (data.success) {
                                // console.log("reCAPTCHA validation successful, score:", data.score);

                                // Add token to form
                                addTokenToForm(formId, token);

                                // Validate the form based on form ID
                                let isValid = false;

                                if (formId === "newsletter-form" || formId == "newsletter-form-hamburger") {
                                    // console.log("Validating newsletter form");
                                    isValid = validateNewsletterForm(form);
                                    if (isValid) {
                                        addScoreField(form, data.score);
                                    }
                                } else {
                                    //  console.log("Validating form with etcStoreValidate");
                                    isValid = etcStoreValidate(form);
                                    // console.log("isValid? ", isValid)
                                    if (isValid) {
                                        addScoreField(form, data.score);
                                    }
                                }
                                // console.log("Form validation result:", isValid);
                                if (isValid) {
                                    if(formId == 'newsletter-form' || formId == "newsletter-form-hamburger"){
                                        submitNewsletterFormByID(form)
                                    }else{
                                        // Set the action and submit
                                        submitBackupData(formId);
                                        submitFormById(formId, form);
                                    }
                                } else {
                                    // Re-enable submit button if validation fails
                                    if (submitButton) {
                                        submitButton.disabled = false;
                                        submitButton.textContent = originalButtonText;
                                    }
                                }
                            } else {
                                // reCAPTCHA validation failed - log as bot
                                console.log("reCAPTCHA validation failed - logging as bot");
                                logBotFormSubmission(form, data.score || 0);

                                // alert("Security validation failed. Please try again.");
                                console.error("reCAPTCHA validation failed:", data.error);

                                // Re-enable submit button
                                if (submitButton) {
                                    submitButton.disabled = false;
                                    submitButton.textContent = originalButtonText;
                                }
                            }
                        })
                        .catch((error) => {
                            console.error("Error validating reCAPTCHA:", error);
                            alert("An error occurred. Please try again.");

                            // Re-enable submit button
                            if (submitButton) {
                                submitButton.disabled = false;
                                submitButton.textContent = originalButtonText;
                            }
                        });
                });
        });
    }

    function submitNewsletterFormByID(form) {
        const actionUrl = "https://4124572.extforms.netsuite.com/app/site/crm/externalleadpage.nl";
        const formElement = form;
        const params = new URLSearchParams(new FormData(formElement));
        // console.log("these are the params passed", params)
        if (!formElement) {
            console.error(`Form with ID ${form.id} not found`);
            return;
        }

        const li = formElement.closest("li");
        const success = li ? li.querySelector(".secondary-nav__form-success") : null;
        const error = formElement.querySelector(".secondary-nav__form-error");
        const button = formElement.querySelector('button[type="submit"]');

        if (button) button.disabled = true;
        if (error) error.hidden = true;

        fetch(actionUrl, {
            method: "POST",
            mode: "no-cors",
            body: params,
        })
            .then(() => {
                // formElement.hidden = true;
                // if (success) success.hidden = false;
                // let formEnd = document.querySelector('#' + form.id)
                // formEnd.style = 'display: none;'
                const wrap = formElement.closest('li') || formElement.parentElement;
                const success = wrap ? wrap.querySelector('.secondary-nav__form-success') : null;
                formElement.style.display = 'none';
                if (success) {
                    success.hidden = false;
                    success.style.display = 'block';
                }
            })
            .catch((e) => {
                console.error("Newsletter submit failed:", e);
                if (error) {
                    error.textContent = "Something went wrong. Please try again.";
                    error.hidden = false;
                }
                if (button) button.disabled = false;
            })
            .finally(() => {});
    }
    // add score field for NS submission
    function addScoreField(form, score) {
        // console.log("score: ",score);
        let existingScoreInput = form.querySelector(
            'input[name="custentity_f9_recaptcha_score"]',
        );
        if (existingScoreInput) {
            existingScoreInput.remove();
        }

        let scoreInput = document.createElement("input");
        scoreInput.type = "hidden";
        scoreInput.name = "custentity_f9_recaptcha_score";
        scoreInput.value = score;
        form.appendChild(scoreInput);
    }

    // Log failed reCAPTCHA attempts as bot submissions
    function logBotFormSubmission(form, score) {
        // Add score to form as hidden input
        let existingScoreInput = form.querySelector(
            'input[name="recaptcha_score"]',
        );
        if (existingScoreInput) {
            existingScoreInput.remove();
        }

        let scoreInput = document.createElement("input");
        scoreInput.type = "hidden";
        scoreInput.name = "recaptcha_score";
        scoreInput.value = score;
        form.appendChild(scoreInput);

        // Add bot detected flag to form
        let existingBotFlag = form.querySelector('input[name="bot_detected"]');
        if (existingBotFlag) {
            existingBotFlag.remove();
        }

        let botFlagInput = document.createElement("input");
        botFlagInput.type = "hidden";
        botFlagInput.name = "bot_detected";
        botFlagInput.value = "recaptcha_failed";
        form.appendChild(botFlagInput);

        // Now send to bot_form.php with all form data including the new hidden inputs
        var formData = new FormData(form);
        // console.log("FormData: ", formData);
        fetch({
            url: "https://formscabinetstogo.com/bot_form.php",
            method: "POST",
            data: formData,
            processData: false,
            contentType: false,
            success: function (response) {
                console.log("Bot data logged successfully");
            },
            error: function (xhr, status, error) {
                console.log("Error logging bot data: ", error);
            },
        });
    }

    // Submit form with appropriate action
    function submitFormById(formId, form) {
        const actionUrl =
            "https://4124572.extforms.netsuite.com/app/site/crm/externalleadpage.nl?";
        // console.log("FormId: ", formId);
        // console.log("Form: ", form);
        // Get the form by ID to ensure we're submitting the correct one
        const formElement = document.getElementById(formId);

        if (!formElement) {
            console.error(`Form with ID ${formId} not found`);
            return;
        }


        if (formElement !== form) {
            console.warn("Form reference mismatch - using form from ID");
        }

        formElement.setAttribute("action", actionUrl);
        // if (formId === "newsletter-form") {
            formElement.setAttribute("target", "formLoadingFrame");
            // console.log("Newsletter form target set to footerNewsLoadingFrame");
            let iframe;
            if(formId == 'newCustomFormScript'){
                formElement.setAttribute("target", "formLoadingFrame");
                iframe = form.parentElement.querySelector('#formLoadingFrame')
                // console.log("iframe element ", iframe)
            }
            else if( formId == 'catalog-request-form'){
                formElement.setAttribute("target", "formLoadingFramePopup");
                iframe = form.parentElement.querySelector('#formLoadingFrame')
                // console.log("iframe element ", iframe)
            }
            if (iframe) {
                // console.log("Found iframe, making it visible");
                iframe.style.display = "block";
                iframe.style.visibility = "visible";
                iframe.style.height = "300px"; // Adjust as needed
                iframe.style.width = "100%";

                // Hide the form
                formElement.style.display = "none";

                // Optional: Add a loading message
                // const loadingMsg = document.createElement("div");
                // loadingMsg.className = "form-loading-message";
                // loadingMsg.textContent = "Submitting...";
                // formElement.parentNode.insertBefore(loadingMsg, iframe);
            }
        // }
        // Remove the event listener to prevent loop
        const newForm = formElement.cloneNode(true);
        formElement.parentNode.replaceChild(newForm, formElement);

        // Now submit without triggering our event listener
        newForm.submit();
    }

    function submitBackupData(formId) {
        // Get form data from the form ID
        const formElement = document.getElementById(formId);

        if (!formElement) {
            console.error(`Form with ID ${formId} not found`);
            return;
        }

        // Create FormData from the form element
        var formData = new FormData(formElement);

        // Optional: Log to verify data is captured
        // console.log("Sending backup data for form:", formId);
        for (let pair of formData.entries()) {
            // console.log(pair[0] + ': ' + pair[1]);
        }

        fetch({
            url: "https://formscabinetstogo.com/process_quote_form.php",
            method: "POST",
            data: formData,
            processData: false,
            contentType: false,
            success: function (response) {
                console.log("Backup data sent successfully:", response);
            },
            error: function (xhr, status, error) {
                console.log("Error sending backup data:", error);
            },
        });
    }

    // Add reCAPTCHA token to form
    function addTokenToForm(formId, token) {
        let form = document.getElementById(formId);
        let existingToken = form.querySelector('input[name="recaptcha_token"]');

        if (existingToken) {
            existingToken.remove();
        }

        let tokenInput = document.createElement("input");
        tokenInput.type = "hidden";
        tokenInput.name = "recaptcha_token";
        tokenInput.value = token;
        tokenInput.required = true;
        form.appendChild(tokenInput);
    }

    // // Attach event listeners to forms (only if they exist)
    // const catalogForm = document.getElementById("catalog-request-form");
    // if (catalogForm) {
    //     catalogForm.addEventListener("submit", function (e) {
    //         e.preventDefault();
    //         handleFormSubmit(this);
    //     });
    // }

    // const etcForm = document.getElementById("etcCustomFormScript");
    // if (etcForm) {
    //     etcForm.addEventListener("submit", function (e) {
    //         e.preventDefault();
    //         handleFormSubmit(this);
    //     });
    // }

    // const newsletterForm = document.getElementById("newsletter-form");
    // if (newsletterForm) {
    //     newsletterForm.addEventListener("submit", function (e) {
    //         e.preventDefault();
    //         // console.log("Newsletter form submit event triggered");
    //         handleFormSubmit(this);
    //     });
    // }
// });
